import { BrowserRouter } from "react-router-dom";

import Root from "./components/Root";

function App() {
  return (
    <>
      <BrowserRouter>
        <Root></Root>
      </BrowserRouter>
    </>
  );
}

export default App;
